module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_8011.3a39539c.png";